import type { MonitorAlert, MonitorAlertKind } from './interview-stream-host.type'

export const FACE_COUNTDOWN_SECONDS = 30
export const CAMERA_OFF_COUNTDOWN_SECONDS = 30
export const FULLSCREEN_COUNTDOWN_SECONDS = 30

export const NO_FACE_MESSAGE = 'INTERVIEW INVALID WARNING: Face undetected, please check camera and ensure that face is visible throughout the interview.'

export function multipleFacesMessage(count: number): string {
    return `INTERVIEW INVALID WARNING: Multiple participants detected (${count}). This interview must be completed individually.`
}

const ALERT_PRIORITY: Record<MonitorAlertKind, number> = {
    camera_off: 3,
    multiple_faces: 2,
    no_face: 1,
}

export function pickActiveAlert(alerts: Partial<Record<MonitorAlertKind, MonitorAlert>>): MonitorAlert | null {
    const entries = Object.values(alerts).filter((alert): alert is MonitorAlert => alert != null)
    if (entries.length === 0) {
        return null
    }
    return entries.sort((a, b) => ALERT_PRIORITY[b.kind] - ALERT_PRIORITY[a.kind])[0] ?? null
}

export function createAlert(kind: MonitorAlertKind, message: string, faceCount?: number): MonitorAlert {
    return {
        kind,
        message,
        faceCount,
        countdownSeconds: null,
    }
}
